<template>
  <el-dialog
    :title="form.id > 0 ? '编辑客户' : '新增客户'"
    :visible.sync="visible"
    class="mini"
    width="960px"
    @close="$emit('update:show', false)"
    @open="handleOpen"
    :close-on-click-modal="false"
    append-to-body
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="120px"
      size="small"
      class="form-flex"
    >
      <el-form-item label="中文名" prop="name" class="long">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        v-if="auth.isPlatformUser()"
        class="blank-form-item"
      ></el-form-item>
      <el-form-item label="英文名" prop="name_en" class="long">
        <el-input v-model="form.name_en" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="SAP Code" v-if="auth.isPlatformUser()">
        <el-input
          v-model="form.sap_code"
          placeholder="请输入SAP Code"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户状态">
        <el-select
          v-model="form.status"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="(value, index) in CustomerStatusMap"
            :key="index"
            :label="value"
            :value="parseInt(index)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户类别" v-if="auth.isPlatformUser()">
        <el-select
          v-model="form.category"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="(value, name) in CustomerCategroyMap"
            :key="name"
            :label="value"
            :value="parseInt(name)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="销售" v-if="!form.id > 0 && auth.isPlatformUser()">
        <sale-select
          :val="form.platform_user_id"
          :role="FunctionalRoles.Sale"
          @change="form.platform_user_id = $event"
          style="width: 100%"
        ></sale-select>
      </el-form-item>
      <el-form-item
        label="电话销售"
        class="long"
        v-if="!form.id > 0 && auth.isPlatformUser()"
      >
        <telesale-select
          :val="form.telesale_id"
          :role="FunctionalRoles.Telesale"
          @change="form.telesale_id = $event"
          style="width: 100%"
        ></telesale-select>
      </el-form-item>
      <el-form-item
        label="代理商"
        v-if="auth.isPlatformUser() && form.category == 6"
      >
        <dealer-customer-select
          style="width: 100%"
          :val="form.dealer_customer_id"
          :isNotFinalCustomer="true"
          @change="form.dealer_customer_id = $event"
        ></dealer-customer-select>
      </el-form-item>
      <el-form-item
        label="售后服务销售商"
        v-if="auth.isPlatformUser() && form.category == 6"
      >
        <dealer-customer-select
          style="width: 100%"
          :val="form.service_customer_id"
          :isNotFinalCustomer="true"
          @change="form.service_customer_id = $event"
        ></dealer-customer-select>
      </el-form-item>
      <el-form-item label="直销/间销客户" v-if="auth.isPlatformUser()">
        <el-select v-model="form.special_mark" class="long">
          <el-option :value="1" key="1" label="直销"></el-option>
          <el-option :value="2" key="2" label="间销"></el-option>
          <el-option :value="0" key="0" label="其他"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="重点客户" v-if="auth.isPlatformUser()">
        <el-select v-model="form.important" class="long">
          <el-option :value="0" key="0" label="请选择"></el-option>
          <el-option :value="1" key="1" label="否"></el-option>
          <el-option :value="2" key="2" label="是"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="级别(服务)" v-if="auth.isPlatformUser()">
        <CustomerRankSelect v-model="form.rank"></CustomerRankSelect>
      </el-form-item>
      <!-- <el-form-item label="级别(工业)" v-if="auth.isPlatformUser()">
          <CustomerRankSelect v-model="form.rank_industry"></CustomerRankSelect>
        </el-form-item>
        <el-form-item label="级别(科学)" v-if="auth.isPlatformUser()">
          <CustomerRankSelect v-model="form.rank_science"></CustomerRankSelect>
        </el-form-item> -->
      <el-form-item label="区域" v-if="auth.isPlatformUser()">
        <area-select
          :val="form.area_id"
          @change="form.area_id = $event"
        ></area-select>
      </el-form-item>
      <el-form-item label="地区">
        <el-cascader
          size="small"
          class="long"
          :props="{ checkStrictly: true }"
          :options="regionData"
          v-model="form.area"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="地址">
        <el-input v-model="form.address_detail" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="所属行业" prop="industry">
        <el-cascader
          v-model="form.industry"
          style="width: 100%"
          :options="DeviceApplicationOptions"
          :props="{ checkStrictly: true }"
          clearable
        ></el-cascader>
      </el-form-item>
      <el-form-item label="规模" prop="scale">
        <el-input
          size="small"
          v-model="form.scale"
          placeholder="请输入规模"
        ></el-input>
      </el-form-item>
      <el-form-item label="来源" prop="source">
        <el-input
          size="small"
          v-model="form.source"
          placeholder="请输入来源"
        ></el-input>
      </el-form-item>
      <el-form-item label="代理人姓名" prop="agent_name">
        <el-input
          v-model="form.agent_name"
          placeholder="代理人姓名"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="代理人手机号" prop="agent_mobile">
        <el-input
          v-model="form.agent_mobile"
          autocomplete="off"
          maxlength="20"
          placeholder="代理人手机号"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="可见商品PH"
        prop="mp_visible_phs"
        v-if="auth.isPlatformUser()"
      >
        <template slot="label"
          >可见商品PH<CustomTip :t="1"></CustomTip
        ></template>
        <el-select
          style="width: 100%"
          v-model="form.mp_visible_phs"
          multiple
          filterable
          allow-create
          default-first-option
          placeholder="请选择或输入PH后回车创建"
        >
          <el-option
            v-for="item in CommodityPhs"
            :key="item.value"
            :label="item.value"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <template v-if="auth.isPlatformUser() && form.category == 6">
        <el-form-item label="中间商可见" prop="is_dealer_visible">
          <template slot="label"
            >中间商可见<CustomTip :t="8"></CustomTip
          ></template>
          <el-select v-model="form.is_dealer_visible" class="long">
            <el-option :value="1" key="1" label="否"></el-option>
            <el-option :value="2" key="2" label="是"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="OEM可见" prop="is_oem_visible">
          <template slot="label"
            >OEM可见<CustomTip :t="9"></CustomTip
          ></template>
          <el-select v-model="form.is_oem_visible" class="long">
            <el-option :value="1" key="1" label="否"></el-option>
            <el-option :value="2" key="2" label="是"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-if="[1, 2, 3].includes(form.category)">
        <el-divider class="mini"></el-divider>
        <!-- <el-form-item
          label="销售(服务)"
          v-if="!form.id > 0 && auth.isPlatformUser()"
        >
          <sale-select
            :val="form.platform_user_id"
            :role="FunctionalRoles.Sale"
            @change="form.platform_user_id = $event"
            style="width: 100%"
          ></sale-select>
        </el-form-item> -->
        <el-form-item
          label="销售(工业)"
          v-if="!form.id > 0 && auth.isPlatformUser()"
        >
          <sale-select
            :val="form.industry_sale_id"
            :role="FunctionalRoles.Sale"
            @change="form.industry_sale_id = $event"
            style="width: 100%"
          ></sale-select>
        </el-form-item>
        <el-form-item
          label="销售(科学)"
          v-if="!form.id > 0 && auth.isPlatformUser()"
        >
          <sale-select
            :val="form.science_sale_id"
            :role="FunctionalRoles.Sale"
            @change="form.science_sale_id = $event"
            style="width: 100%"
          ></sale-select>
        </el-form-item>
        <el-form-item
          label="授权服务商"
          prop="is_fix_dealer"
          class="long"
          v-if="auth.isPlatformUser()"
        >
          <el-select v-model="form.is_fix_dealer" class="long">
            <el-option :key="0" label="否" :value="0"></el-option>
            <el-option :key="1" label="是" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="联系人姓名" prop="contact_name">
        <el-input v-model="form.contact_name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="联系人手机号" prop="contact_phone_number">
        <el-input
          v-model="form.contact_phone_number"
          autocomplete="off"
          maxlength="11"
          placeholder="联系人手机号"
        ></el-input>
      </el-form-item> -->
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="form.email"
            autocomplete="off"
            placeholder="邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="OM邮箱" prop="email" v-if="auth.isPlatformUser()">
          <el-input
            v-model="form.om_email"
            autocomplete="off"
            placeholder="OM邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="EC有效期" prop="ec_deadline">
          <el-date-picker
            style="width: 100%"
            v-model="form.ec_deadline"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
      </template>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { regionData } from '@/util/area_tool'
import { createCustomer, updateCustomer } from '@/service/getData'
import {
  CustomerCategroyMap,
  FunctionalRoles,
  CustomerStatusMap,
  CsutomerIndustries,
  DeviceApplicationOptions,
  CommodityPhs,
} from '@/config/global.js'
import auth from '@/util/auth'
import SaleSelect from '@/components/select/sale_select'
import TelesaleSelect from '@/components/select/telesale_select'
import AreaSelect from '@/components/select/area_select'
import DealerCustomerSelect from '@/components/select/dealer_customer_select'

export default {
  components: {
    SaleSelect,
    TelesaleSelect,
    AreaSelect,
    DealerCustomerSelect,
  },
  props: {
    model: {
      type: Object,
    },
    category: {
      type: Number,
      default: 6,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  created() {
    if (this.category) {
      this.form.category = this.category
    }
    this.industries = CsutomerIndustries.map((item) => {
      return {
        value: item,
      }
    })
  },
  data() {
    return {
      form: {
        name: '',
        name_en: '',
        sap_code: '',
        status: 1,
        category: 6,
        is_fix_dealer: 0,
        telesale_id: 0,
        is_dealer_visible: 1,
        is_oem_visible: 1,
        platform_user_id: 0,
        rank: 0,
        industry_sale_id: 0,
        rank_industry: 0,
        science_sale_id: 0,
        rank_science: 0,
        contact_name: '',
        contact_phone_number: '',
        email: '',
        om_email: '',
        special_mark: 0,
        important: 1,
        area_id: 0,
        area: [],
        province: '',
        city: '',
        county: '',
        address_detail: '',
        industry: [],
        source: '',
        scale: '',
        agent_name: '',
        agent_mobile: '',
        ec_deadline: null,
        dealer_customer_id: 0,
        service_customer_id: 0,
        mp_visible_phs: [],
      },
      FunctionalRoles,
      auth,
      regionData,
      CommodityPhs,
      CustomerCategroyMap,
      CustomerStatusMap,
      DeviceApplicationOptions,
      visible: this.show,
      rules: {
        name: [
          { required: true, message: '请填写该项', trigger: 'blur' },
          {
            min: 2,
            max: 15,
            max: 100,
            message: '长度在 2 到 100 个字符',
          },
        ],
        contact_name: [
          { required: true, message: '请填写该项', trigger: 'blur' },
          {
            min: 2,
            max: 40,
            message: '长度在 2 到 40 个字符',
            trigger: 'blur',
          },
        ],
        contact_phone_number: [
          {
            required: true,
            pattern: /^1\d{10}$/,
            message: '手机号错误',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    handleOpen() {
      if (this.model && this.model.id) {
        this.form = this.model
        this.form.area = []
        if (this.form.province) {
          this.form.area.push(this.form.province)
        }
        if (this.form.city) {
          this.form.area.push(this.form.city)
        }
        if (this.form.county) {
          this.form.area.push(this.form.county)
        }
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let area = this.form.area
          if (area.length > 0) {
            this.form.province = area[0]
          }
          if (area.length > 1) {
            this.form.city = area[1]
          }
          if (area.length > 2) {
            this.form.county = area[2]
          }

          if (this.form.id > 0) {
            let res = await updateCustomer(this.form)
            if (res.code == 0) {
              this.$emit('updatedCustomer', res.data)
              this.visible = false
            }
          } else {
            let res = await createCustomer(this.form)
            if (res.code == 0) {
              this.$emit('createdCustomer', res.data)
              this.visible = false
            }
          }
        }
      })
    },
  },
}
</script>

<style scoped>
.el-autocomplete {
  width: 100%;
}
</style>